/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Session_Label_PoolInputs */

const bn_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`পুল: ${i?.value}`)
};

const de_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pool: ${i?.value}`)
};

const el_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Πισίνα: ${i?.value}`)
};

const en_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pool: ${i?.value}`)
};

const es_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Piscina: ${i?.value}`)
};

const fr_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pool : ${i?.value}`)
};

const hi_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पूल: ${i?.value}`)
};

const hu_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Medence: ${i?.value}`)
};

const id_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kolam renang: ${i?.value}`)
};

const it_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Piscina: ${i?.value}`)
};

const ja_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プール: ${i?.value}`)
};

const ko_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`풀: ${i?.value}`)
};

const nl_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zwembad: ${i?.value}`)
};

const pl_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Basen: ${i?.value}`)
};

const pt_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Piscina: ${i?.value}`)
};

const ru_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пул: ${i?.value}`)
};

const sv_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pool: ${i?.value}`)
};

const tr_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Havuz: ${i?.value}`)
};

const uk_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пул: ${i?.value}`)
};

const vi_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bể bơi: ${i?.value}`)
};

const zh_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`池：${i?.value}`)
};

const zh_hant_session_label_pool = /** @type {(inputs: Session_Label_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`池：${i?.value}`)
};

/**
* | output |
* | --- |
* | "Pool: {value}" |
*
* @param {Session_Label_PoolInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const session_label_pool = /** @type {((inputs: Session_Label_PoolInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Label_PoolInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_session_label_pool(inputs)
	if (locale === "de") return de_session_label_pool(inputs)
	if (locale === "el") return el_session_label_pool(inputs)
	if (locale === "en") return en_session_label_pool(inputs)
	if (locale === "es") return es_session_label_pool(inputs)
	if (locale === "fr") return fr_session_label_pool(inputs)
	if (locale === "hi") return hi_session_label_pool(inputs)
	if (locale === "hu") return hu_session_label_pool(inputs)
	if (locale === "id") return id_session_label_pool(inputs)
	if (locale === "it") return it_session_label_pool(inputs)
	if (locale === "ja") return ja_session_label_pool(inputs)
	if (locale === "ko") return ko_session_label_pool(inputs)
	if (locale === "nl") return nl_session_label_pool(inputs)
	if (locale === "pl") return pl_session_label_pool(inputs)
	if (locale === "pt") return pt_session_label_pool(inputs)
	if (locale === "ru") return ru_session_label_pool(inputs)
	if (locale === "sv") return sv_session_label_pool(inputs)
	if (locale === "tr") return tr_session_label_pool(inputs)
	if (locale === "uk") return uk_session_label_pool(inputs)
	if (locale === "vi") return vi_session_label_pool(inputs)
	if (locale === "zh") return zh_session_label_pool(inputs)
	return zh_hant_session_label_pool(inputs)
});